import React from 'react';
import { useAuth } from '../context/AuthContext';
import Dashboard from './Dashboard';
import UserDashboardPage from './UserDashboardPage';

const DashboardHomePage = () => {
  const { user } = useAuth();

  if (user?.role === 'user' || user?.role === 'supervisor') {
    return <UserDashboardPage />;
  }

  return <Dashboard />;
};

export default DashboardHomePage;
